import { render } from "./index.vue?vue&type=template&id=4d420a8d&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=4d420a8d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d420a8d"]])

export default __exports__